var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLucideRocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 48.0001H16C16 48.0001 18.2 35.8801 24 32.0001C30.48 27.6801 44 32.0001 44 32.0001M48 60.0001V80.0001C48 80.0001 60.12 77.8001 64 72.0001C68.32 65.5201 64 52.0001 64 52.0001",
    stroke: "#F5DB8B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 66C12 71.04 10 86 10 86C10 86 24.96 84 30 78C32.84 74.64 32.8 69.48 29.64 66.36C28.0852 64.8761 26.0372 64.0186 23.8889 63.9521C21.7406 63.8857 19.6435 64.615 18 66ZM48 60L36 48C38.1286 42.4777 40.8088 37.1843 44 32.2C48.6607 24.748 55.1505 18.6122 62.852 14.3764C70.5535 10.1406 79.2107 7.9455 88 8.00001C88 18.88 84.88 38 64 52C58.9469 55.1937 53.5868 57.8738 48 60Z",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucideRocket);
export default __webpack_public_path__ + "static/media/lucide_rocket.94fa417727e4cad6ac2588789572f263.svg";
export { ForwardRef as ReactComponent };